import { Component, OnInit, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { Message} from 'primeng/primeng';
import { BinnacleService} from '../services/binnacle.service';
import { Table } from 'primeng/components/table/table';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-binnacle',
  templateUrl: './binnacle.component.html',
  styleUrls: ['./binnacle.component.css']
})
export class BinnacleComponent implements OnInit {

    msgs: Message[] = [];
    binnacle: any;
    binnacles : any [];
    blockedDocument: boolean = false;
    fileName:String;
    cols: any[];
    dateOptions: SelectItem[];
    dateOption: any;
    disabledInitialDate: boolean;
    disabledFinalDate: boolean;
    initialDate: Date;
    finalDate: Date;

    @ViewChild('dt') table: Table;

    constructor(private binnacleService : BinnacleService) { }

    ngOnInit() {
      this.fileName = "bitacora";
      this.cols = [
              { field: 'idBinnacle', header: 'NRO.' },
              { field: 'dateTime', header: 'FECHA/HORA' },
              { field: 'nickName', header: 'USUARIO' },
              { field: 'ipAddress', header: 'IP' },
              { field: 'descriptionActionType', header: 'ACCION' },
              { field: 'channel', header: 'CANAL' },
              { field: 'observation', header: 'OBSERVACION' }
          ];
      this.dateOptions = [
        {label: 'Hoy', value: 'T', icon: 'fa fa-calendar-check-o'},
        {label: 'Ayer', value: 'Y', icon: 'fa fa-calendar-minus-o'},
        {label: 'Ultimos 7 dias', value: '7', icon: 'fa fa-calendar'},
        {label: 'Otro', value: 'O', icon: 'fa fa-calendar-o'}
      ];
      this.dateOption = 'Y';
      this.changeDate();
    }

    changeDate(){
      this.disabledInitialDate = true;
      this.disabledFinalDate = true;
      if(this.dateOption == 'T'){
        this.initialDate = new Date();
        this.finalDate = new Date();
        this.initialDate.setHours(0,0,0);
        this.finalDate.setHours(23,59,59);
      }else if(this.dateOption == 'Y'){
        this.initialDate = new Date();
        this.finalDate = new Date();
        this.initialDate.setDate(this.initialDate.getDate() - 1);
        this.initialDate.setHours(0,0,0);
        this.finalDate.setDate(this.finalDate.getDate() - 1);
        this.finalDate.setHours(23,59,59);
      }else if(this.dateOption == '7'){
        this.initialDate = new Date();
        this.finalDate = new Date();
        this.initialDate.setDate(this.initialDate.getDate() - 6);
        this.initialDate.setHours(0,0,0);
        this.finalDate.setHours(23,59,59);
      }else{
        this.disabledInitialDate = false;
        this.disabledFinalDate = false;
      }
    }

    diferenciaEntreFechasEnDias(a:Date, b:Date):number{
      return Math.floor((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));
    }

    buscar(){
      if(this.table){
        this.table.first=1;
      }
      this.fileName="bitacora";

      if(this.diferenciaEntreFechasEnDias(this.initialDate,this.finalDate) > 35){
        this.msgs = [{severity:'error', summary:'ERROR', detail:"El rango de fechas no debe exceder los 35 dias"}];
        return;
      }
      this.binnacles = [];
      this.blockedDocument = true;

      this.binnacleService.findBetweenDates(this.initialDate,this.finalDate).then(data => {
        let response: any = data;
        response.binnacles.forEach(item => {
          this.binnacles.push(item);
        });
        this.blockedDocument = false;
      }).catch(err =>{
          this.msgs = [{severity:'error', summary:'ERROR', detail:"Error de conexión, comprueba la conexión a internet y vuelva a intentar"}];
          this.blockedDocument = false;
      });

    }

    exportXLS(){
      let records = [];
      this.binnacles.forEach(item=>{
        let data = {};
        this.cols.forEach(col => {
          data[col.header] = item[col.field];
        });
        records.push(data);
      });

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(records);
      const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
      XLSX.writeFile(workbook, this.fileName+".xlsx");
    }

}



// WEBPACK FOOTER //
// ./src/app/binnacle/binnacle.component.ts